export const GA_MEASUREMENT_ID = "G-4VMRSJBW9F";

export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined") return;

  // gtag is added via index.html.
  if (typeof window.gtag !== "function") return;

  window.gtag("event", eventName, {
    transport_type: "beacon",
    ...params,
  });
}

export function trackTryKnoothClick(location) {
  trackEvent("try_knooth_click", {
    // Use a distinctive param name so it can be registered as a Custom Dimension in GA4.
    cta_location: location,
    // Kept for backward compatibility with any existing GA4 setups.
    location,
    link_url: "https://apps.apple.com/app/knooth/id6756659300?mt=12",
  });
}
